import React, {Component} from 'react';
import '../css/Page.css';

class PageUfficioGareEsterno extends Component {

    render() {
        return (
                <div className="page">
                    <article>

                        <p>L&rsquo;Ufficio Gare Esterno propone di offrire alle Imprese un valido
                            supporto nell&rsquo;individuazione e nella partecipazione alla gare d&rsquo;appalto di lavori.
                            <br/>Il servizio Ufficio Gare Esterno &egrave; in grado di offrire alle Imprese,
                            su tutto il territorio nazionale, la consulenza, l&rsquo;assistenza e la preparazione di tutta
                            la documentazione occorrente per la partecipazione alle gare di appalto, con la sola esclusione
                            del ribasso che sar&agrave; poi indicato dall&rsquo;Impresa stessa.
                            <br/>Le aree di competenza dell&rsquo;ufficio gare sono numerose e i suoi servizi sono
                            organizzati in modo da soddisfare ogni tipo di richiesta ed esigenza dell'azienda,
                            dalla preparazione completa della documentazione per partecipare alla gara,
                            all'assistenza tecnica, ai servizi integrati.</p>

                        <p>Il servizio in particolare &egrave; stato studiato per soddisfare le esigenze delle aziende come ad esempio:</p>
                        <ul>
                            <li>poter usufruire di un vero e proprio ufficio gare in outsourcing (Esterno), con una grande ottimizzazione dei costi di personale;</li>
                            <li>partecipare nell&rsquo;immediato alle gare d&rsquo;appalto, soprattutto alle imprese che non possiedono adeguata esperienza del mondo degli appalti;</li>
                            <li>rimediare ad assenze del personale aziendale addetto alla preparazione delle gare;</li>
                        </ul>

                        <h3>Si offrono anche soluzioni in abbonamento del tipo fisso mensile che verrà concordato a
                            seconda del tipo e del numero di servizi di cui l’Impresa decide di usufruire (preventivi personalizzati). </h3>

                        <p>Per richiedere il servizio vi preghiamo di inviare i seguenti documenti tramite mail.</p>
                        <p>Mail:&nbsp;<a href="mailto:info@areamultiservice.it">info@areamultiservice.it</a> e/o <a href="mailto:serviziappalti@libero.it">serviziappalti@libero.it</a></p>
                        <p>Per ulteriori informazioni contattare il responsabile Ufficio Gare al numero <strong>329/8177540</strong>.</p>

                    </article>
                </div>
        );
    }
}

export default PageUfficioGareEsterno;


// WEBPACK FOOTER //
// ./src/page/js/PageUfficioGareEsterno.js